// @ts-nocheck
import type {
  AdminAuthChangePassword200,
  AdminAuthForgotPassword200,
  AdminAuthLogout200,
  AdminAuthMe200,
  AdminAuthResetPassword200,
  AdminAuthUpdateProfile200,
  AdminChangePasswordRequest,
  AdminForgotPasswordRequest,
  AdminLoginRequest,
  AdminRefreshRequest,
  AdminResetPasswordRequest,
  AdminSessionResource,
  AdminUpdateProfileRequest
} from '../types';

import { httpClient } from '../../../http';



  export const getAdminAuth = () => {
/**
 * @summary Sign in as staff
 */
const adminAuthLogin = (
    adminLoginRequest: AdminLoginRequest,
 ) => {
      return httpClient<AdminSessionResource>(
      {url: `/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminLoginRequest
    },
      );
    }
  /**
 * @summary Exchange a staff refresh token for new tokens
 */
const adminAuthRefresh = (
    adminRefreshRequest: AdminRefreshRequest,
 ) => {
      return httpClient<AdminSessionResource>(
      {url: `/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminRefreshRequest
    },
      );
    }
  /**
 * @summary Email a staff password reset link
 */
const adminAuthForgotPassword = (
    adminForgotPasswordRequest: AdminForgotPasswordRequest,
 ) => {
      return httpClient<AdminAuthForgotPassword200>(
      {url: `/auth/forgot-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminForgotPasswordRequest
    },
      );
    }
  /**
 * @summary Reset a staff password with an emailed token
 */
const adminAuthResetPassword = (
    adminResetPasswordRequest: AdminResetPasswordRequest,
 ) => {
      return httpClient<AdminAuthResetPassword200>(
      {url: `/auth/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminResetPasswordRequest
    },
      );
    }
  /**
 * @summary Sign out of this staff session
 */
const adminAuthLogout = (

 ) => {
      return httpClient<AdminAuthLogout200>(
      {url: `/auth/logout`, method: 'POST'
    },
      );
    }
  /**
 * @summary Show the signed-in staff member
 */
const adminAuthMe = (

 ) => {
      return httpClient<AdminAuthMe200>(
      {url: `/auth/me`, method: 'GET'
    },
      );
    }
  /**
 * @summary Update the signed-in staff member
 */
const adminAuthUpdateProfile = (
    adminUpdateProfileRequest?: AdminUpdateProfileRequest,
 ) => {
      return httpClient<AdminAuthUpdateProfile200>(
      {url: `/auth/profile`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUpdateProfileRequest
    },
      );
    }
  /**
 * @summary Change the signed-in staff password
 */
const adminAuthChangePassword = (
    adminChangePasswordRequest: AdminChangePasswordRequest,
 ) => {
      return httpClient<AdminAuthChangePassword200>(
      {url: `/auth/password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminChangePasswordRequest
    },
      );
    }
  return {adminAuthLogin,adminAuthRefresh,adminAuthForgotPassword,adminAuthResetPassword,adminAuthLogout,adminAuthMe,adminAuthUpdateProfile,adminAuthChangePassword}};
export type AdminAuthLoginResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminAuthLogin']>>>
export type AdminAuthRefreshResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminAuthRefresh']>>>
export type AdminAuthForgotPasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminAuthForgotPassword']>>>
export type AdminAuthResetPasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminAuthResetPassword']>>>
export type AdminAuthLogoutResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminAuthLogout']>>>
export type AdminAuthMeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminAuthMe']>>>
export type AdminAuthUpdateProfileResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminAuthUpdateProfile']>>>
export type AdminAuthChangePasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['adminAuthChangePassword']>>>
